import { ChangeDetectionStrategy, Component, ElementRef, OnInit, Optional, Renderer2, ViewChild } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { UgcImageGalleryComponent } from '../ugc-image-gallery.component';
import { NUgcImageGallery } from '../ugc-image-gallery.namespace';
import { ProductViewLayoutComponent } from './../../../../catalog/product/view-layout/product-view-layout.component';
@Component({
    selector: 'ugc-image-gallery-cms-product-view',
    template: '<ugc-image-gallery [content]="component" [product]="product"></ugc-image-gallery>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [UgcImageGalleryComponent]
})
@ICmsComponent<UgcImageGalleryCmsProductViewComponent>({
    id: 'ugc-image-gallery-product-view',
    name: 'User Generated Content Image Gallery Layout for PDP',
    tags: ['ugc', 'gallery', 'product view'],
    onDemandOnly: true,
    fields: NUgcImageGallery.FIELDS
})
export class UgcImageGalleryCmsProductViewComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component?: NUgcImageGallery.IData;

    @ViewChild(UgcImageGalleryComponent)
    ugcImageGalleryComponent?: UgcImageGalleryComponent;

    constructor(
        protected elementRef: ElementRef,
        protected renderer2: Renderer2,
        @Optional() public productViewLayoutComponent: ProductViewLayoutComponent
    ) {
        super();
        this.updateVisibility();
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.productViewLayoutComponent?.productView?.modelChange.subscribe(() => this.detectChanges()));
    }

    updateVisibility() {
        this.timeoutService.setTimeout(() => {
            this.ugcImageGalleryComponent?.images?.length || this.client.isCms
                ? this.renderer2.removeClass(this.elementRef.nativeElement, 'visually-hidden')
                : this.renderer2.addClass(this.elementRef.nativeElement, 'visually-hidden');
        }, 100);
    }

    get product() {
        return this.productViewLayoutComponent?.product;
    }
}
